<template lang="pug" src="./dashboard.pug"> </template>
<style scoped lang="scss" src="./dashboard.scss"> </style>

<script>
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'
import Loader from '@/components/Loader/loader'

export default {
    components: {
        'overview-card': () => import('@/components/OverviewCard'),
        'v-chart': () => ({
            component: import('@/components/Chart/chart.vue'),
            loading: Loader
        })
    },
    data: () => ({
        dataValues: [],
        formatBalance: 'day',
        formatReferrals: 'day',
        formatTable: 'day',
        formatOrders: 'day'
    }),
    computed: {
        ...mapGetters(['type', 'user']),
        ...mapState({
            balanceHistory: (state) => state.dashboard.balanceHistory,
            referralsHistory: (state) => state.dashboard.referralsHistory,
            ordersHistory: (state) => state.dashboard.ordersHistory,
            referralsHistoryTable: (state) => state.dashboard.referralsHistoryTable,
            balanceHistoryTable: (state) => state.dashboard.balanceHistoryTable,
            ordersHistoryTable: (state) => state.dashboard.ordersHistoryTable,
            isTableLoad: (state) => state.dashboard.isLoaded,
            numberOfClients: (state) => state.data.numberOfClients,
            numberOfBusinesses: (state) => state.data.numberOfBusinesses,
            user: state => state.app.user
        }),
        dataLoaded() {
            return !this.isTableLoad
        },
        isDisableReferrals: function() {
            return this.referralsHistory.every(it => !it.total)
        },
        headers: function() {
            return [...this.referralsHistoryTable.map(it => ({ text: it[this.formatTable] }))]
        },
        items: function() {
            const result = [{
                text: 'clients',
                totals: this.referralsHistoryTable.map('total')
            }, {
                text: 'balance',
                totals: this.balanceHistoryTable.map('total')
            }, {
                text: 'deliveryOrders',
                totals: this.ordersHistoryTable.map('deliveryOrders')
            }]

            // ['online', 'offline'].forEach(it => {
            //     result.push({
            //         text: it,
            //         totals: this.balanceHistoryTable.map(it)
            //     })
            // })

            return result
        },
        datesChart: function() {
            const typeSelects = '$vuetify.pages.Dashboard.dateMenu'
            return ['month', 'day'].map(it => ({
                text: this.$vuetify.t(`${typeSelects}.${it}`),
                value: it
            }))
        },
        datesTable: function() {
            const typeSelects = '$vuetify.pages.Dashboard.dateMenu'
            return ['month', 'day'].map(it => ({
                text: this.$vuetify.t(`${typeSelects}.${it}`),
                value: it
            }))
        },
        totalOnlineFee() {
            const fee = this.user && this.user.fee

            const items = [fee]

            if (this.user && this.type === 'business' && this.user.processedAfterRestrictions) {
                items.push(this.user.leaderFee)
            }

            return items
                .filter(Boolean)
                .map(it => Vue.filter('percent')(it))
                .join(' + ')
        },
        totalOfflineFee() {
            const telephonyFee = this.user && this.user.telephonyFee
            const leaderTelephonyFee = this.user && this.user.type === 'business' && this.user.leaderTelephonyFee

            return [telephonyFee, leaderTelephonyFee]
                .filter(Boolean)
                .map(it => Vue.filter('percent')(it))
                .join(' + ')
        },
        overviewCards: function() {
            const result = [{
                title: this.$vuetify.t(`$vuetify.pages.Dashboard.overviewBalance`),
                value: Vue.filter('currency')(this.user && this.user.balance),
                icon: '/img/icons/chart.svg',
                permission: ['leader', 'business'],
                balance: true
            },
            //     {
            //     title: this.$vuetify.t(`$vuetify.pages.Dashboard.overviewFee`),
            //     value: this.totalOnlineFee,
            //     icon: '/img/icons/percent.svg',
            //     permission: ['leader', 'business'],
            //     fee: true
            // },
            {
                title: this.$vuetify.t(`$vuetify.pages.Dashboard.overviewBusinesses`),
                value: this.numberOfBusinesses || 0,
                icon: '/img/icons/business.svg',
                permission: ['leader']
            }, {
                title: this.$vuetify.t(`$vuetify.pages.Dashboard.overviewClients`),
                value: this.numberOfClients || 0,
                icon: '/img/icons/client.svg',
                permission: ['leader', 'business']
            }, {
                title: this.$vuetify.t(`$vuetify.pages.Dashboard.clientBase`),
                value: Vue.filter('limits')(this.user && this.user.clientBase, this.user && this.user.unlimitedRights),
                icon: '/img/icons/storage.svg',
                permission: ['leader']
            }, {
                title: this.$vuetify.t(`$vuetify.pages.Dashboard.accountLimit`),
                value: Vue.filter('limits')(this.user && this.user.accountLimit, this.user && this.user.unlimitedRights),
                icon: '/img/icons/beenhere.svg',
                permission: ['leader']
            }
            //     {
            //     title: this.$vuetify.t(`$vuetify.pages.Dashboard.clientLimit`),
            //     value: Vue.filter('limits')(this.user && this.user.clientLimit, this.user && this.user.unlimitedRights),
            //     icon: '/img/icons/beenhere.svg',
            //     permission: ['business']
            // },
            //     {
            //     title: this.$vuetify.t(`$vuetify.pages.Dashboard.autoPromoBalance`),
            //     value: Vue.filter('currency')(this.user && this.user.autoPromoBalance),
            //     icon: '/img/icons/promo.svg',
            //     permission: ['leader', 'business']
            // }
            ]

            // if (this.user && this.user.processedAfterRestrictions) {
            //     result.push({
            //         title: this.$vuetify.t(`$vuetify.pages.Dashboard.promoBalance`),
            //         value: Vue.filter('currency')(this.user && this.user.promoBalance),
            //         icon: '/img/icons/promo_manual.svg',
            //         permission: ['leader']
            //     })
            // }

            // if (this.user && this.user.includeTelephony) {
            //     const feeIndex = result.findIndex(it => it.fee)
            //
            //     result.splice(feeIndex + 1, 0, {
            //         title: this.$vuetify.t(`$vuetify.pages.Dashboard.overviewTelephonyFee`),
            //         value: this.totalOfflineFee,
            //         icon: '/img/icons/telephony_fee.svg',
            //         permission: ['leader', 'business']
            //     })
            // }

            return result
        }
    },
    created: function() {
        this.$store.dispatch('getNumberOfReferrals')

        const actions = [
            'getAccountBalanceHistoryByDate',
            'getReferralsHistoryByDate',
            'getOrdersHistoryByDate'
        ]

        Promise.all(actions.map(action => {
            this.$store.dispatch(`dashboard/${action}`, {
                chart: true,
                table: true,
                format: 'day'
            })
        }))
    },
    methods: {
        isShow(types) {
            return types.includes(this.type)
        },
        onBalanceChangeDate(date) {
            this.formatBalance = date
            this.$store.dispatch('dashboard/getAccountBalanceHistoryByDate', {
                chart: true,
                format: date
            })
        },
        onReferralChangeDate(date) {
            this.formatReferrals = date
            this.$store.dispatch('dashboard/getReferralsHistoryByDate', {
                chart: true,
                format: date
            })
        },
        onOrderHistoryChange(date) {
            this.formatOrders = date
            this.$store.dispatch('dashboard/getOrdersHistoryByDate', {
                chart: true,
                format: date
            })
        },
        onTableFormatChange(date) {
            this.formatTable = date
            this.$store.dispatch('dashboard/getReferralsHistoryByDate', {
                table: true,
                format: date
            })
            this.$store.dispatch('dashboard/getAccountBalanceHistoryByDate', {
                table: true,
                format: date
            })
            this.$store.dispatch('dashboard/getOrdersHistoryByDate', {
                table: true,
                format: date
            })
        }
    }
}
</script>
